<template>
  <modal :show.sync="showModal">
    <h6 slot="header" class="modal-title">Editar Categoría: {{fetchCategory.name}}</h6>
    <form class="needs-validation" id="formEditCategory"
        @keyup.enter="eventoEnter($event)"
        @submit.prevent="sendForm($event)">
      <div class="form-row">
        <div class="col-md-12">
          <base-input label="Nombre"
                      name="nombre"
                      placeholder="Ingrese un nombre"
                      :error="getError('nombre')"
                      v-validate="'required'"
                      v-model="category.name">
          </base-input>
        </div>
      </div>
    </form>

    <template slot="footer">
      <base-button type="primary" nativeType="submit" form="formEditCategory">Guardar Cambios</base-button>
      <base-button type="link" class="ml-auto" @click="showModal = false">Cancelar</base-button>
    </template>

  </modal>
</template>
<script>
  export default {
    components: {
        
    },
    data() {
      return {
        validated: false,
        category: {
            id: '',
          name: '',
        },
        fetchCategory: {
          name: '',

        },
        showModal: false,
        change_password: "0",
        reglasConfirmacion: '',
        reglasPassword: '',
        category_id: null,
        permisos_editable: false
      }
    },
    methods: {
      eventoEnter(evt){
          console.log('metodo EventoEnter: ');
          //console.log(evt);
          evt.stopPropagation();
      },
      async firstFormSubmit() {
        try {
          return await this.$validator.validateAll();
          //throw new Error('hno ke wea esta wea');
        } catch {
          console.log('Oh, tengo ke caputar algo');
          return false;
        }
        finally {
          this.validated = true;
        }
      },
      getError(name){
        return this.errors.first(name)
      },
      isValid(name) {
        return this.validated && !this.errors.has(name);
      },
      sendForm(evt){
          console.log('metodo sendForm: ');
          console.log(evt);
        var vm = this;
        this.firstFormSubmit().then( response => {
          console.log('retorno promesa de validacion', response);
          
          if( response ){
            
            vm.axios({
                method: 'PUT',
                url: 'api/edit_category',
                data: {   
                          category: vm.category.id,
                          name: vm.category.name,
                      }
            }).then( response => {
              vm.$notify({
                      message: 'Categoría editada exitosamente!',
                      timeout: 5000,
                      icon: 'ni ni-bell-55',
                      type: 'success'
                  });
              // Cerrar el Modal
              vm.showModal = false;
              // Emitir evento para que actualize la tabla de usuarios
              vm.$emit('successSending');
            }).catch( error => {
                
                if( error.response.status == 422){
                  Object.entries(error.response.data.errors).forEach( elem => {
                    vm.$notify({
                      message: elem[1][0],
                      timeout: 5000,
                      icon: 'ni ni-bell-55',
                      type: 'danger'
                    });
                  });
                }else{
                  console.log(error);
                  vm.$notify({
                        message: 'Hubo un error, no se pudo modificar la categoría',
                        timeout: 5000,
                        icon: 'ni ni-bell-55',
                        type: 'default'
                    });
                }
            });
          }
          
        }).catch( reason => {
          console.log(reason);
        });
      },
      fetchDataTeam(category_id)
      {
        var vm = this;
        
        return this.axios({
            method: 'GET',
            url: 'api/edit_category?category='+category_id
        }).then(response => {
            this.fetchCategory.name = this.category.name = response.data.name;
            this.fetchCategory.id = this.category.id = response.data.id;
            this.showModal = true;
            this.category_id = category_id;
        }).catch( error => {
            console.log(error);
        })
        ;
      },
    },
    mounted()
    {
        
    },
    created()
    {
      this.$parent.$on('loadModalEditCategory', (category_id) => { this.fetchDataTeam(category_id) } );
    },
  }
</script>
<style>
</style>
